import { Injectable } from '@angular/core';
import {ProgressSpinnerComponent} from '../../components/ui/progress-spinner/progress-spinner.component';
import {Overlay, OverlayRef} from '@angular/cdk/overlay';
import {ComponentPortal} from '@angular/cdk/portal';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private overlayConfig = {
    hasBackdrop: true,
    positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically()
  };
  private overlayRef: OverlayRef;
  private spinnerOverlayPortal = new ComponentPortal(ProgressSpinnerComponent);

  constructor(private overlay: Overlay) {
    this.overlayRef = this.overlay.create(this.overlayConfig);
  }

  show(): void {
    if (!this.overlayRef.hasAttached()) {
      this.overlayRef = this.overlay.create(this.overlayConfig);
      this.overlayRef.attach(this.spinnerOverlayPortal);
    }
  }

  hide(): void {
    this.overlayRef.dispose();
  }
}
